<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="封禁天数" prop="disableDays" >
        <a-input-number v-model="form.disableDays" placeholder="请输入封禁天数" allow-clear :min="0" :max="9999" />
      </a-form-model-item>
      <a-form-model-item label="封禁日期" prop="disableTime" >
        <a-date-picker format="YYYY-MM-DD" mode="date":disabledDate="disabledDate" v-model="form.disableTime"  placeholder="请输入封禁日期" />
      </a-form-model-item>
      <a-form-model-item label="封禁原因" prop="disableReason" >
        <a-input type="textarea" v-model="form.disableReason" placeholder="请输入封禁原因" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUser, disableUser } from '@/api/user/user'
import Editor from '@/components/Editor'
import {delTable} from "@/api/tool/gen";
import request from "@/utils/request";
import moment from "moment";

export default {
  name: 'ChangeMobileForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      mobile:null,
      remark:null,
      // 表单参数
      form: {
        id: null,

        userId: null,
        disableTime:null,
        disableDays:null,
        disableReason:null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用戶id，外键{user.id}不能为空', trigger: 'blur' }
        ],
        disableTime: [
          { required: true, message: '封禁日期不能为空', trigger: 'blur' },
        ],
        disableDays: [
          { required: true, message: '封禁天数不能为空', trigger: 'blur' },
        ],
        disableReason: [
          { required: true, message: '原因不能为空', trigger:'blur' },
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    disabledDate(current) {
      return current && current<moment().subtract(1,"d").endOf("day");
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        type: null,
        content: null,
        resourceId: null,
        resourceType: null,
        processStatus: 0,
        processResult: null,
        createTime: null,
        remark: null,
        noticeStatus:0,
      }
      this.mobile = null;
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {

      this.resourceId = row.resourceId;

      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUser({"id":id}).then(response => {
        this.form = response.data
        this.form.userId = id
        this.open = true
        this.formTitle = '封禁用戶'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      let that = this;
      that.$refs.form.validate(valid => {
        if (valid) {
          that.submitLoading = true
          if (that.form.id !== undefined && that.form.id !== null) {
            //时间格式化
            that.form.disableTime = that.form.disableTime?that.form.disableTime.format('YYYY-MM-DD'):null;
            let formData ={
              "userId":that.form.id,
              "disableTime":that.form.disableTime,
              "disableDays":that.form.disableDays,
              "disableReason":that.form.disableReason,
            }
            disableUser(formData).then(response => {
              that.$message.success(
                '修改成功',
                3
              )
              that.open = false
              that.$emit('ok')
            }).finally(() => {
              that.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
